export default __webpack_public_path__ + "static/media/direct_print_Dark2.a00b80f9.svg";